import { render, staticRenderFns } from "./OnboardingDialogContent.vue?vue&type=template&id=5b9e2d83&"
import script from "./OnboardingDialogContent.vue?vue&type=script&setup=true&lang=ts&"
export * from "./OnboardingDialogContent.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports